/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import { PluginCommands } from 'molstar/lib/mol-plugin/commands';
import axios from "axios";
import { updateIsActivated, updateIsDetected, updateIsLoaded } from './components/HookStateUpdate';
axios.defaults.xsrfHeaderName = "X-CSRFToken";
axios.defaults.xsrfCookieName = "csrftoken";
export default axios


export const WarningMessage = (errormessage) => {
    var toggleMessage = document.getElementById('messageWarning');
    var spanText = document.getElementById('textWarning');
    if (typeof errormessage == "object") {
        if (errormessage.response !== undefined) {
            errormessage = `${errormessage} ${errormessage.response.data.detail}`;
        }
    }
    spanText.textContent = errormessage;
    if (toggleMessage.classList.contains('hidden') === true) {
        toggleMessage.classList.toggle('hidden');
    }
    toggleMessage.scrollIntoView({behavior: 'smooth'});
}

export const HiddenWarningMessage = () => {
    var toggleMessage = document.getElementById('messageWarning');
    if (toggleMessage) {
        if (toggleMessage.classList.contains('hidden') === false) {
            toggleMessage.classList.toggle('hidden');
        }
    }
}

export const WarningMessagePlugin = (plugin, message) => {
    PluginCommands.Toast.Show(plugin, {
        title: 'Warning',
        message: message,
        key: 'Warning'
    });
}

export const JobMessage = (message, color, url) => {
    var toggleMessage = document.getElementById('messageJob');
    toggleMessage.classList.remove('job-yellow');
    toggleMessage.classList.add(`job-${color}`);
    var toggleButton = document.getElementById('buttonJob');
    toggleButton.classList.remove('job-button-yellow');
    toggleButton.classList.add(`job-button-${color}`);
    var spanText = document.getElementById('textJob');
    spanText.textContent = message;
    if (url) {
        var br = document.createElement('br');
        var a = document.createElement('a');
        spanText.appendChild(br);
        spanText.appendChild(a);
        a.href = url
        a.textContent = url
    }
    if (toggleMessage.classList.contains('hidden') === true) {
        toggleMessage.classList.toggle('hidden');
    }
    toggleMessage.scrollIntoView({behavior: 'smooth'});
}

export const HiddenJobMessage = () => {
    var toggleMessage = document.getElementById('messageJob');
    if (toggleMessage) {
        if (toggleMessage.classList.contains('hidden') === false) {
            toggleMessage.classList.toggle('hidden');
        }
    }
}

export const randomColor = () => {
    return "0x" + Math.floor(Math.random() * 16777215).toString(16);
}

export const startbarUpload = (id) => {
    document.getElementById(`inputbar-${id}`).hidden = true;
    document.getElementById(`divbar-${id}`).hidden = false;


}

export const progressbarUpload = (id, percent) => {
    var progressbar = document.getElementById(`progressbar-${id}`);
    progressbar.style.width = `${percent}%`
    progressbar.textContent = `${percent}%`;

}

export const finishbarUpload = (id) => {
    document.getElementById(`inputbar-${id}`).hidden = false;
    document.getElementById(`divbar-${id}`).hidden = true;

}


export const SetHrefMessage = (url) => {
    const ref = document.getElementById('href');
    ref.href = url
    ref.textContent = url
    const hrefmessage = document.getElementById('messageUrl');
    if (hrefmessage.classList.contains('hidden') === true) {
        hrefmessage.classList.toggle('hidden');
    }
}


export const HiddenHrefMessage = () => {
    const ref = document.getElementById('href');
    ref.href = '#'
    ref.textContent = ''
    const hrefmessage = document.getElementById('messageUrl');
    if (hrefmessage) {
        if (hrefmessage.classList.contains('hidden') === false) {
            hrefmessage.classList.toggle('hidden');
        }
    }
}

export const CleanMessages = () => {
    updateIsLoaded(false);
    updateIsActivated(false);
    updateIsDetected(false);
    HiddenJobMessage();
    HiddenHrefMessage();
    HiddenWarningMessage();
}